import React, { Fragment, useCallback } from "react";
import { EAuditStatus, IAuditListFilters } from "../../../interfaces/IAudit";
import { Form, Icon, InputProps } from "semantic-ui-react";
import "./_AuditFiltersForm.less";
import { useApplicationConfiguration } from "../../../configuration/ConfigurationContext";
import { FormTypeSelect } from "../../formType/FormTypeSelect";
import { AuditStatusSelect } from "../audit/AuditStatusSelect";
import { useTranslation } from "react-i18next";
import PersonSearch from "../../../../sg-hpr/components/persons/PersonSearch/PersonSearch";


interface AuditFiltersFormProps {
    formData: IAuditListFilters;
    onChange?: (formData: IAuditListFilters) => void;
    onUpdate?: (formData: Partial<IAuditListFilters>) => void;
    labels?: boolean;
    inline?: boolean;
    hideStatusFilter?: boolean;
    hideFreetextFilter?: boolean;
}

export const AuditFiltersForm: React.FC<AuditFiltersFormProps> = ({
    formData,
    onChange,
    onUpdate,
    labels = false,
    inline = true,
    hideStatusFilter = false,
    hideFreetextFilter = false
}) => {
    const { t } = useTranslation();

    const texts = {
        type: t("Tyyppi"),
        status: t("Tila"),
        responsiblePerson: t("Vastuuhenkilö"),
        search: t("Haku")

    }
    const { components: { LocationFilter } } = useApplicationConfiguration();

    const update = useCallback((partial: Partial<IAuditListFilters>) => {
        if (onChange) onChange({ ...formData, ...partial });
        if (onUpdate) onUpdate(partial)
    }, [formData, onChange, onUpdate]);

    const Wrapper = inline ? Form.Group : Fragment;


    const updateFormType = (formType?: number) => update({ formType });
    const updateResponsiblePerson = (responsiblePerson?: number | number[] | null) => update({ responsiblePerson: Array.isArray(responsiblePerson) ? responsiblePerson[0] : responsiblePerson || undefined });
    const updateStatus = (status?: EAuditStatus) => update({ status });
    const updateFreeText: InputProps["onChange"] = (_1, { value }) => update({ freeText: value });

    return (
        <Form className="AuditFiltersForm-form" as="div">
            <Wrapper className="AuditFiltersForm-group" inline widths="equal" >

                {LocationFilter ? (
                    <LocationFilter
                        className="AuditFiltersForm-select"
                        filters={formData}
                        onChange={update}
                    />
                ) : null}

                <FormTypeSelect
                    className="AuditFiltersForm-select"
                    value={formData.formType}
                    onChange={updateFormType}
                    placeholder={texts.type}
                    clearable
                    fluid
                />

                <Form.Field className="AuditFiltersForm-select">
                    <PersonSearch
                        style={{ width: "100%" }}
                        value={formData.responsiblePerson}
                        placeholder={texts.responsiblePerson}
                        onChange={updateResponsiblePerson}
                        isMulti={false}
                        requiredCerts={[]}
                    />
                </Form.Field>

                {!hideStatusFilter && <AuditStatusSelect
                    className="AuditFiltersForm-select"
                    value={formData.status}
                    onChange={updateStatus}
                    placeholder={texts.status}
                    clearable
                    fluid
                />}

                {!hideFreetextFilter && <Form.Input
                    className="AuditFiltersForm-input"
                    placeholder={texts.search}
                    icon={<Icon name="search" />}
                    value={formData.freeText}
                    onChange={updateFreeText}
                    iconPosition="left"
                    fluid
                />}


            </Wrapper>

        </Form>
    )
}